import config from '../config';

//公共图片路径处理文件
export function forMat() {
  return config.fontUrl;
}

//截取文件名称
export function intercept(url) {
  let originname = url.split('/')[url.split('/').length - 1]; //获取最后‘/’后的带时间戳的文件名
  let filename = originname.slice(13); //从第14位开始截取，去掉13位时间戳
  return filename;
}

// 上传文件地址
export function baseFileUrl() {
  return config.baseUploadUrl;
}
// 观众登录的地址

export function hzExhibitionLogin() {
  return config.hzExhibitionLogin;
}
// 展商登录的地址
export function hzAudienceLogin() {
  return config.hzAudienceLogin;
}
// 展商个人中心后台
export function hzExhibitionIndex() {
  return config.hzExhibitionIndex;
}
// 观众个人中心后台
export function hzAudienceIndex() {
  return config.hzAudienceIndex;
}
// 展会官网
export function hzZhanhui() {
  return config.hzzhanhui;
}
// 我要参展
export function viewcz() {
  return config.viewcz;
}
// 我要参观
export function viewcg() {
  return config.viewcg;
}
// 展位图
export function zwt() {
  return config.zwt;
}
// 展会日程
export function zhrc() {
  return config.zhrc;
}
// 观众后台得消息
export function messageUrl() {
  return config.messageUrl;
}
// 判断浏览器的头是否为移动端
export function perfix() {
  // header 手机特征信息
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
    //显示移动端的代码
    return 'mobile/';
  } else {
    //显示非移动端的代码
    return '';
  }
}
export function testDomain(){
  return config.testDomain
}